import { c as _c } from "react/compiler-runtime";
import { cn } from '@core/utils';
import { Suspense } from 'react';
import { Image } from '@/components/client';
import { BenefitsBanner } from './BenefitsBanner';
interface MainInfoSectionProps {
  title: string;
  summary: string;
  description: string;
  institutionId: number;
  backgroundVideoImageUrl: string;
  pcBackgroundVideoImageUrl?: string;
  logoUrl: string;
}
const DUMMY_HERO_IMAGE_URL = 'https://cdn.welfarehello.com/static/institution-hero-common.png';
export const MainInfoSection = t0 => {
  const $ = _c(55);
  const {
    title,
    summary,
    description,
    institutionId,
    backgroundVideoImageUrl,
    pcBackgroundVideoImageUrl,
    logoUrl
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = cn("absolute z-[1] size-full", "mobile-tablet:hidden");
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== logoUrl || $[2] !== title) {
    t2 = <Image src={logoUrl} alt={title} width={48} height={48} className="rounded-pill" />;
    $[1] = logoUrl;
    $[2] = title;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== title) {
    t3 = <h1 className="font-800 text-Gray-white typo-h4">{title}</h1>;
    $[4] = title;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t2 || $[7] !== t3) {
    t4 = <div className="shrink-0 basis-[360px] flex-col gap-20 flex-center">{t2}{t3}</div>;
    $[6] = t2;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <div className="h-102 border-l-1 border-Gray-white/60" />;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== summary) {
    t6 = <p className="whitespace-pre-line break-keep text-left font-700 text-Gray-white typo-h5">{summary}</p>;
    $[10] = summary;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== description) {
    t7 = <div className="whitespace-pre-line break-keep text-left font-500 text-Gray-white typo-body2 [&_p]:!text-Gray-white [&_span]:!text-Gray-white" dangerouslySetInnerHTML={{
      __html: description
    }} />;
    $[12] = description;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== t6 || $[15] !== t7) {
    t8 = <div className="flex grow-[3] flex-col gap-16 pl-120">{t6}{t7}</div>;
    $[14] = t6;
    $[15] = t7;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] !== t4 || $[18] !== t8) {
    t9 = <div className={t1}><div className="my-auto size-full gap-40 flex-center content-container">{t4}{t5}{t8}</div></div>;
    $[17] = t4;
    $[18] = t8;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  const t10 = backgroundVideoImageUrl ?? DUMMY_HERO_IMAGE_URL;
  let t11;
  if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = cn("aspect-[500/346] w-full object-cover", "hidden mobile-tablet:block");
    $[20] = t11;
  } else {
    t11 = $[20];
  }
  let t12;
  if ($[21] !== t10) {
    t12 = <Image src={t10} alt={"\uC9C0\uC790\uCCB4 \uD788\uC5B4\uB85C \uC774\uBBF8\uC9C0"} width={850} height={588} className={t11} />;
    $[21] = t10;
    $[22] = t12;
  } else {
    t12 = $[22];
  }
  const t13 = pcBackgroundVideoImageUrl ?? DUMMY_HERO_IMAGE_URL;
  let t14;
  if ($[23] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = cn("aspect-[1920/456] w-full object-cover", "mobile-tablet:hidden");
    $[23] = t14;
  } else {
    t14 = $[23];
  }
  let t15;
  if ($[24] !== t13) {
    t15 = <Image src={t13} alt={"\uC9C0\uC790\uCCB4 \uD788\uC5B4\uB85C \uC774\uBBF8\uC9C0"} width={1920} height={456} className={t14} />;
    $[24] = t13;
    $[25] = t15;
  } else {
    t15 = $[25];
  }
  let t16;
  if ($[26] === Symbol.for("react.memo_cache_sentinel")) {
    t16 = <div style={{
      background: "linear-gradient(180deg, rgba(0, 0, 0, 0.00) 50%, rgba(0, 0, 0, 0.60) 100%), rgba(0, 0, 0, 0.30)"
    }} className={cn("absolute inset-0", "mobile-tablet:hidden")} />;
    $[26] = t16;
  } else {
    t16 = $[26];
  }
  let t17;
  if ($[27] === Symbol.for("react.memo_cache_sentinel")) {
    t17 = cn("absolute bottom-0 left-20 hidden translate-y-1/2 rounded-pill object-cover shadow-lg", "mobile-tablet:block");
    $[27] = t17;
  } else {
    t17 = $[27];
  }
  let t18;
  if ($[28] !== logoUrl || $[29] !== title) {
    t18 = <Image src={logoUrl} alt={title} width={72} height={72} className={t17} />;
    $[28] = logoUrl;
    $[29] = title;
    $[30] = t18;
  } else {
    t18 = $[30];
  }
  let t19;
  if ($[31] !== t12 || $[32] !== t15 || $[33] !== t18 || $[34] !== t9) {
    t19 = <div className="relative">{t9}{t12}{t15}{t16}{t18}</div>;
    $[31] = t12;
    $[32] = t15;
    $[33] = t18;
    $[34] = t9;
    $[35] = t19;
  } else {
    t19 = $[35];
  }
  let t20;
  if ($[36] === Symbol.for("react.memo_cache_sentinel")) {
    t20 = cn("hidden px-20 pt-48", "mobile-tablet:block");
    $[36] = t20;
  } else {
    t20 = $[36];
  }
  let t21;
  if ($[37] !== title) {
    t21 = <h1 className="mb-6 font-700 text-Gray-black typo-h6">{title}</h1>;
    $[37] = title;
    $[38] = t21;
  } else {
    t21 = $[38];
  }
  let t22;
  if ($[39] !== summary) {
    t22 = <p className="mb-16 whitespace-pre-line font-500 text-Gray-700 typo-body3">{summary}</p>;
    $[39] = summary;
    $[40] = t22;
  } else {
    t22 = $[40];
  }
  let t23;
  if ($[41] !== description) {
    t23 = <p className="text-Gray-600 typo-body3 [&_p]:!text-[14px] [&_p]:!text-Gray-600 [&_span]:!text-[14px] [&_span]:!text-Gray-600" dangerouslySetInnerHTML={{
      __html: description
    }} />;
    $[41] = description;
    $[42] = t23;
  } else {
    t23 = $[42];
  }
  let t24;
  if ($[43] !== t21 || $[44] !== t22 || $[45] !== t23) {
    t24 = <div className={t20}>{t21}{t22}{t23}</div>;
    $[43] = t21;
    $[44] = t22;
    $[45] = t23;
    $[46] = t24;
  } else {
    t24 = $[46];
  }
  let t25;
  if ($[47] === Symbol.for("react.memo_cache_sentinel")) {
    t25 = cn("mt-32 px-40 content-container", "mobile-tablet:mt-34 mobile-tablet:px-20");
    $[47] = t25;
  } else {
    t25 = $[47];
  }
  let t26;
  if ($[48] === Symbol.for("react.memo_cache_sentinel")) {
    t26 = <div className={cn("aspect-[1200/180] w-full rounded-medium bg-Gray-50", "mobile-tablet:aspect-[335/120]")} />;
    $[48] = t26;
  } else {
    t26 = $[48];
  }
  let t27;
  if ($[49] !== institutionId) {
    t27 = <div className={t25}><Suspense fallback={t26}><BenefitsBanner institutionId={institutionId} /></Suspense></div>;
    $[49] = institutionId;
    $[50] = t27;
  } else {
    t27 = $[50];
  }
  let t28;
  if ($[51] !== t19 || $[52] !== t24 || $[53] !== t27) {
    t28 = <section>{t19}{t24}{t27}</section>;
    $[51] = t19;
    $[52] = t24;
    $[53] = t27;
    $[54] = t28;
  } else {
    t28 = $[54];
  }
  return t28;
};